@if (errorCode == 200) {
  <div class="invoice_paypopup mobsuccesscontainer" [ngClass]="paymentDetails?.cardNumber?'schpay-successcontainer':''">
    <div class="order_panel_header successcontainer">
      <div class="row">
        <div class="col-md-12">
          @if (!paymentDetails?.cardNumber) {
            <div class="title_data">{{"iframesection.thankyoumsg" | cxTranslate}}</div>
          } @else {
            <div class="title_data">{{"iframesection.schpaythankyoumsg" | cxTranslate}}</div>
          }
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="msg_data">
            {{"iframesection.thankyoumsg2" | cxTranslate}} @if (!paymentDetails?.cardNumber) {
            Customer Service at &nbsp;<a href="mailto:customerservice.us@seqirus.com" target="_blank">{{emailId}}</a>.
            }@if (paymentDetails?.cardNumber) {
            <a routerLink="/contact-us" class="schpay_link">Customer Service</a>.
          }
        </div>
      </div>
    </div>
    @if (!paymentDetails?.cardNumber) {
      <div class="row">
        <div class="col-md-6 col-xs-10 marginClass">
          <div class="Transactiontext">{{"iframesection.transactionidlabel" | cxTranslate}}<div class="tractionid">{{paymentDetails.companyCode}}/{{paymentDetails.invoiceNumber}}</div>
        </div>
      </div>
    </div>
  } @else {
    <div class="new_schedule_pay_banner">
      <div class="marginClass">
        <div class="Transactiontext">{{"iframesection.datelabel" | cxTranslate}}<div class="tractionid">{{paymentDetails.currentDate}}</div>
      </div>
    </div>
    <div class="marginClass">
      <div class="Transactiontext second_buttontext">{{"iframesection.cardlabel" | cxTranslate}}<div class="tractionid">@if (paymentDetails.cardType == '1') {
        <img width="38" class="image" src="../../assets/images/Visa_icon.png"
          alt="Visa">
      }
      @if (paymentDetails.cardType == '2') {
        <img width="38" class="image" src="../../assets/images/amex_icon.png"
          alt="American Express">
      }
      @if (paymentDetails.cardType == '3') {
        <img width="38"class="image" src="../../assets/images/master_icon.png"
          alt="MasterCard">
      }
      @if (paymentDetails.cardType == '128') {
        <img width="38" class="image" src="../../assets/images/Discover_icon.png"
          alt="Discover">
      }
    **{{paymentDetails.cardNumber.slice(-4)}}</div>
  </div>
</div>
</div>
}
@if (!paymentDetails?.cardNumber) {
  <div class="row">
    <div class="col-md-6 col-xs-6 close_container">
      <a href="/financial-dashboard/all-invoices" target="_parent" class="close_btn_thankyou mobclose_btn">{{"iframesection.closelabel" | cxTranslate}}</a>
    </div>
  </div>
} @else {
  <div class="new_schedule_pay_buttons">
    <div class="close_container">
      <a href="/scheduled-payments" target="_parent" class="close_btn_thankyou view_sch_pay mobclose_btn">{{"iframesection.viewallschpay" | cxTranslate}}</a>
    </div>
    <div class="close_container">
      <a href="/financial-dashboard/all-invoices" target="_parent" class="close_btn_thankyou mobclose_btn">{{"iframesection.closelabel" | cxTranslate}}</a>
    </div>
  </div>
}
</div>
</div>
}
@if (errorCode==3) {
  <div class="invoice_paypopup paymentfailed mobpaddingpayment">
    <div class="order_panel_header successcontainer">
      <div class="row">
        <div class="col-md-12">
          <div class="title_data">{{"iframesection.errortitle1" | cxTranslate}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12" [innerHTML]="'iframesection.errormessage1' | cxTranslate">
        </div>
      </div>
      <div class="row">
        <div class="failerbtncont col-xs-12" id="failurebtncont">
          <div class="failerretry mobretry" id="retry" (click)="cancelClicked()">{{"iframesection.retryorchange" | cxTranslate}}</div>
          <div class="failercancelbtn" id="cancel" (click)="cancelTransactionClicked()">{{"iframesection.canceltransaction" | cxTranslate}}</div>
        </div>
      </div>
    </div>
  </div>
}
@if (errorCode==2) {
  <div class="invoice_paypopup paymentfailed mobpaddingpayment">
    <div class="order_panel_header successcontainer">
      <div class="row">
        <div class="col-md-12">
          <div class="title_data">{{"iframesection.errortitle2" | cxTranslate}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12" [innerHTML]="'iframesection.errormessage2' | cxTranslate">
        </div>
      </div>
      <div class="row">
        <div class="failerbtncont col-xs-12" id="failurebtncont">
          <div class="failerretry mobretry" id="retry" (click)="cancelClicked()">{{"iframesection.retryorchange" | cxTranslate}}</div>
          <div class="failercancelbtn" id="cancel" (click)="cancelTransactionClicked()">{{"iframesection.canceltransaction" | cxTranslate}}</div>
        </div>
      </div>
    </div>
  </div>
}
@if (errorCode==1) {
  <div class="invoice_paypopup paymentfailed mobpaddingpayment">
    <div class="order_panel_header successcontainer">
      <div class="row">
        <div class="col-md-12">
          <div class="title_data">{{"iframesection.errortitle3" | cxTranslate}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12" [innerHTML]="'iframesection.errormessage3' | cxTranslate"></div>
      </div>
      <div class="row">
        <div class="failerbtncont col-xs-12" id="failurebtncont">
          <div class="failerretry mobretry" id="retry" (click)="cancelClicked()">{{"iframesection.retryorchange" | cxTranslate}}</div>
          <div class="failercancelbtn" id="cancel" (click)="cancelTransactionClicked()">{{"iframesection.canceltransaction" | cxTranslate}}</div>
        </div>
      </div>
    </div>
  </div>
}


